// Copyright ©️ 2026 eVolve MEP, LLC

import { FONT_SIZE_MAX, FONT_SIZE_MIN } from 'components/Autodesk/extensions/MarkupModeExtension/constants';

import { SizeField } from './SizeField';

type FontSizeFieldProps = { id: string; label: string; value: string };

export const FontSizeField = (props: FontSizeFieldProps) => (
  <SizeField {...props} min={FONT_SIZE_MIN} max={FONT_SIZE_MAX} step={1} />
);
